import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { ProfileState } from './types';

export const actions: ActionTree<ProfileState, RootState> = {
  /**
   * @param { commit }: actions에서는 mutations를 fetch하기 위한 commit method를 참조로서 제공한다.
   * @param payload: 참조된 commit method 다음부터는 인수를 받을 수 있다.
   */
  fetchData({ commit }, payload): void {
    commit('profileLoaded', payload);
  }
};
